import { render } from "./Agreement.vue?vue&type=template&id=a935b89e"
import script from "./Agreement.vue?vue&type=script&lang=js"
export * from "./Agreement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/Agreement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a935b89e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a935b89e', __exports__)) {
    api.reload('a935b89e', __exports__)
  }
  
  module.hot.accept("./Agreement.vue?vue&type=template&id=a935b89e", () => {
    api.rerender('a935b89e', render)
  })

}


export default __exports__